import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui/Button';

/** Full-screen fallback shown when the error boundary trips. */
export function AppErrorFallback(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 'var(--space-6)',
        textAlign: 'center',
      }}
    >
      <div>
        <p style={{ marginBottom: 'var(--space-4)' }}>{t('errors.generic')}</p>
        <Button onClick={() => window.location.reload()}>{t('common.retry')}</Button>
      </div>
    </div>
  );
}
